module.exports = __webpack_public_path__ + "static/img/2.8254d77.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Todo-riesgo-empresarial/2.png
// module id = ayNW
// module chunks = 0